export default function mergeAndRemoveKey(original, target, isKeepDeleted) {
    const { deleted = [], ...restTarget } = target;
    const copyOriginal = { ...original };
    if (deleted.length > 0) {
        for (const key of deleted) {
            delete copyOriginal[key];
        }
    }
    return {
        ...copyOriginal,
        ...restTarget,
        ...(isKeepDeleted ? { deleted } : {})
    };
}
